<!-- Form Container -->
<div
  data-testid="user-profile-page"
  class="h-[calc(100vh-60px)] flex flex-col overflow-x-hidden"
>
  <!-- Header with action buttons -->
  <div
    class="flex flex-col sm:flex-row justify-between items-start sm:items-center sticky top-0 bg-white z-10 px-4 sm:px-6 pt-4 pb-4 sm:pb-0"
  >
    <h2 class="text-xl sm:text-2xl font-semibold text-gray-800 mb-4 sm:mb-0">
      {{ "user_profile.title" | translate }}
    </h2>
    <div class="flex flex-col sm:flex-row gap-2 sm:gap-3 w-full sm:w-auto">
      @if (false) {
        <div class="flex gap-2 sm:gap-3">
          <app-button
            [testId]="'user-profile-save-or-edit-btn'"
            [label]="
              isEditingProfile()
                ? ('user_profile.headers.save_profile' | translate)
                : ('user_profile.headers.edit_profile' | translate)
            "
            [icon]="isEditingProfile() ? 'check' : 'edit'"
            (emitOnClick)="
              isEditingProfile() ? saveProfile() : toggleProfileEdit()
            "
            [loading]="isSavingProfile()"
            [disabled]="isEditingProfile() && !profileForm.valid"
            type="primary"
            class="text-sm flex-1 sm:flex-none"
          ></app-button>
          <app-button
            [testId]="'user-profile-cancel-edit-btn'"
            *ngIf="isEditingProfile()"
            [label]="'user_profile.headers.cancel' | translate"
            [icon]="'close'"
            (emitOnClick)="cancelProfileEdit()"
            [outlined]="true"
            type="secondary"
            class="text-sm flex-1 sm:flex-none"
          ></app-button>
        </div>
      }
      <app-button
        [testId]="'user-profile-back-btn'"
        [label]="'user_profile.headers.back' | translate"
        [icon]="'arrow_back'"
        (emitOnClick)="goBack()"
        [outlined]="true"
        type="secondary"
        class="text-sm w-full sm:w-auto mt-2 sm:mt-0"
      ></app-button>
    </div>
  </div>

  <!-- Scrollable content area -->
  <div class="flex-1 min-h-0 overflow-auto px-4 sm:px-6">
    <div class="p-4 sm:p-6">
      <!-- User Profile Section -->
      <section class="form-section mb-6 sm:mb-8 max-w-[800px] mx-auto">
        <h2
          class="section-title text-base sm:text-lg font-semibold my-3 mx-2 sm:mb-4 px-4 sm:px-0"
        >
          {{ "user_profile.sections.profile_information" | translate }}
        </h2>

        <div class="bg-gray-50 rounded-xl p-4 sm:p-6 border border-gray-200">
          <!-- User Avatar -->
          <div
            class="flex flex-col sm:flex-row items-center sm:items-start gap-4 sm:gap-6 mb-6 text-center sm:text-left"
          >
            <div class="relative">
              <img
                data-testid="user-profile-avatar-img"
                [src]="userProfile.avatar"
                [alt]="userProfile.username"
                class="w-20 h-20 sm:w-24 sm:h-24 rounded-full object-cover border-4 border-white shadow-lg"
              />
            </div>
            <div class="flex flex-col gap-2 sm:gap-3">
              <h3 class="text-xl sm:text-2xl font-bold text-gray-900">
                {{ userProfile.username }}
              </h3>
              <div class="space-y-2">
                <div
                  class="flex items-center justify-center sm:justify-start gap-2"
                >
                  <span class="text-gray-500 text-sm sm:text-base">📧</span>
                  <span class="text-base sm:text-lg text-gray-700 break-all">{{
                    userProfile.email
                  }}</span>
                </div>
                <div
                  class="flex items-center justify-center sm:justify-start gap-2"
                >
                  <span class="text-gray-500 text-sm sm:text-base">👤</span>
                  <span class="text-base sm:text-lg text-gray-700">{{
                    userProfile.role
                  }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Edit Profile Form -->
          <div *ngIf="isEditingProfile()" class="border-t pt-4 sm:pt-6">
            <form
              data-testid="user-profile-form"
              [formGroup]="profileForm"
              class="space-y-4"
            >
              <!-- Mobile: Stack fields vertically, Desktop: 2 columns -->
              <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div class="form-field">
                  <label
                    for="up-username"
                    class="block text-sm font-medium text-gray-700 mb-2"
                  >
                    {{ "user_profile.fields.username" | translate }}
                  </label>
                  <input
                    data-testid="user-profile-username-input"
                    type="text"
                    id="up-username"
                    formControlName="username"
                    class="w-full px-3 py-3 sm:py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-base sm:text-sm"
                    [placeholder]="
                      'user_profile.placeholders.enter_username' | translate
                    "
                  />
                  <!-- Mobile: Show validation errors inline -->
                  <div
                    *ngIf="
                      profileForm.get('username')?.invalid &&
                      profileForm.get('username')?.touched
                    "
                    class="text-red-500 text-sm mt-1"
                  >
                    <span
                      *ngIf="profileForm.get('username')?.errors?.['required']"
                    >
                      {{ "validation.required" | translate }}
                    </span>
                  </div>
                </div>
                <div class="form-field">
                  <label
                    for="up-email"
                    class="block text-sm font-medium text-gray-700 mb-2"
                  >
                    {{ "user_profile.fields.email" | translate }}
                  </label>
                  <input
                    data-testid="user-profile-email-input"
                    type="email"
                    id="up-email"
                    formControlName="email"
                    class="w-full px-3 py-3 sm:py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-base sm:text-sm"
                    [placeholder]="
                      'user_profile.placeholders.enter_email' | translate
                    "
                  />
                  <!-- Mobile: Show validation errors inline -->
                  <div
                    *ngIf="
                      profileForm.get('email')?.invalid &&
                      profileForm.get('email')?.touched
                    "
                    class="text-red-500 text-sm mt-1"
                  >
                    <span
                      *ngIf="profileForm.get('email')?.errors?.['required']"
                    >
                      {{ "validation.required" | translate }}
                    </span>
                    <span *ngIf="profileForm.get('email')?.errors?.['email']">
                      {{ "validation.email" | translate }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-field">
                <label
                  for="up-role"
                  class="block text-sm font-medium text-gray-700 mb-2"
                >
                  {{ "user_profile.fields.role" | translate }}
                </label>
                <p-select
                  data-testid="user-profile-role-select"
                  formControlName="role"
                  [options]="availableRoles"
                  [placeholder]="
                    'user_profile.placeholders.select_role' | translate
                  "
                  optionLabel="name"
                  optionValue="name"
                  inputId="up-role"
                  class="w-full"
                  [panelStyleClass]="'mobile-select-panel'"
                ></p-select>
                <!-- Mobile: Show validation errors inline -->
                <div
                  *ngIf="
                    profileForm.get('role')?.invalid &&
                    profileForm.get('role')?.touched
                  "
                  class="text-red-500 text-sm mt-1"
                >
                  <span *ngIf="profileForm.get('role')?.errors?.['required']">
                    {{ "validation.required" | translate }}
                  </span>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>

<!-- Toast for messages -->
<p-toast data-testid="user-profile-toast"></p-toast>
